const metrics = [
  { id: 1, title: "Access", detail: "for high-potential learners" },
  { id: 2, title: "Practical", detail: "career-focused programmes" },
  { id: 3, title: "Partner-led", detail: "funded learning pathways" },
];

const ScholarshipMetricsSection = () => {
  return (
    <section
      aria-label="Page highlights"
      className="w-full bg-hire-tint-blue border-t border-b border-hire-line px-6 lg:px-8"
    >
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3">
        {metrics.map((metric, index) => (
          <div
            key={metric.id}
            className={`flex flex-col justify-center min-h-[96px] py-[22px] md:py-[10px] px-0 md:px-[34px] border-b md:border-b-0 md:border-r border-[#ccd7ef] ${
              index === 0 ? "md:pl-0" : ""
            } ${
              index === metrics.length - 1 ? "border-b-0 md:border-r-0" : ""
            }`}
          >
            <strong className="text-primary font-poppins tracking-[-0.035em] text-[31px] leading-tight">
              {metric.title}
            </strong>
            <span className="text-gray font-poppins text-[15px] leading-snug mt-1.5">
              {metric.detail}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ScholarshipMetricsSection;
